/**
 * The message will be shown as an error alert
 * @param {*} message error
 * @param {*} handler a handler to call after ok is clicked
 * @return Promise
 */
const errorAlert = (message, handler) => {
  const controller = document.querySelector("ion-alert-controller");
  return controller
    .create({
      header: "There was an error.",
      message,
      buttons: [
        {
          text: "Ok",
          handler
        }
      ]
    })
    .then(alert => alert.present());
};

export default errorAlert;
